export default {
  takeOverRequestDialog: {
    titleForced: 'Someone else is editing this {resourceType}',
    titleVoluntary: 'Take over editing?',
    message1:
      'The {resourceType} is currently being edited by {user}. You can request to take over the editing process or access the {resourceType} in view mode.',
    message2: 'In <strong>{timer} sec.</strong> the request will be automatically approved.',
    viewOnly: 'View only',
    takeOverEditing: 'Take over editing',
    deniedTitle: 'Take over editing denied. The current editor {user} has denied your request to take over.',
    approvedTitle: 'Take over editing approved. Now you can edit the {resourceType}.'
  },
  takeOverResponseDialog: {
    title: 'Someone requested editing control',
    message1: `Another editor (<strong>{user}</strong>) is requesting to take control to edit this {resourceType}. If you approve their request, all your changes will be saved and you will be switched to view mode.`,
    message2: `In <strong>{timer} sec.</strong>  this request will be automatically approved.`,
    deny: 'Deny take over',
    approve: 'Approve take over',
    savedTitle: 'Your changes were saved. This {resourceType} is now in view mode'
  },
  takeOverCanceledDialog: {
    title: 'Request for edition cancelled',
    message1: `<strong>{user}</strong> has finally cancelled its request for edition on this {resourceType}.`,
    message2: `You can continue working on the {resourceType}.`,
    understood: 'Understood'
  },
  comments: {
    title: 'Comments',
    searching: 'Searching...',
    fillerMessage:
      'Enhance collaboration with others by creating a thread. Click anywhere on the map to add a comment.',
    addCommentPlaceholder: 'Add a comment',
    replies: '{count, plural, =1 {# reply} other {# replies}}',
    resultBy: '{count, plural, =1 {# result by} other {# results by}}',
    deletedUser: 'Deleted User',
    unread: 'Unread',
    editedTag: '(edited)',
    filters: {
      tooltip: 'Filters',
      all: 'All',
      myComments: 'My comments',
      onlyUnread: 'Only unread'
    },
    searchPlaceholder: 'Search comments',
    noComments: 'No comments were found',
    noCommentsMessage: `Try adjusting your search to find the comments you're looking for, or adjust your filters.`,
    resetFilters: 'Show the whole comments list',
    resolved: 'Resolved',
    includeResolved: 'Include resolved',
    markAllAsRead: 'Mark all as read',
    showCommentsOnMap: 'Show comments on map',
    hideCommentsOnMap: 'Hide comments on map',

    actions: {
      showComments: 'Show comments',
      hideComments: 'Hide comments',
      copyLink: 'Copy link',
      markAsResolved: 'Mark as resolved',
      deleteThread: 'Delete thread',
      deleteComment: 'Delete comment',
      reopen: 'Reopen',
      moreActions: 'More actions',
      edit: 'Edit'
    },
    actionTypes: {
      resolved: 'Marked as resolved',
      reopened: 'Reopened'
    },
    notifications: {
      commentsHidden: 'Comments hidden',
      commentsShown: 'Comments shown',
      commentsMarkedAsRead: '{count, plural, =1 {# thread marked as read} other {# threads marked as read}}',
      commentDeleted: 'Comment deleted',
      threadDeleted: 'Thread deleted',
      commentResolved: 'Comment resolved',
      commentReopened: 'Comment reopened',
      linkCopied: 'Link copied to clipboard!'
    },
    deleteThreadConfirm: {
      title: 'Delete thread',
      message: `Are you sure you want to delete this thread? This action can't be undone.`
    },
    deleteCommentConfirm: {
      title: 'Delete comment',
      message: `Are you sure you want to delete this comment? This action can't be undone.`
    },
    popover: {
      commentNo: 'Comment #',
      addComment: 'Add a comment',
      reply: 'Reply',
      replyWillReopen: 'Replying will reopen the thread...'
    },
    maxSuggestionExceededMessage: 'Too many results, please refine your search',
    noSuggestionsMessage: 'No users with access were found'
  }
}
